import { Price } from './models/price';

export enum PricingBreakdownAmountType {
  listingPrice = 'listingPrice',
  buyerFee = 'buyerFee',
  fullPrice = 'fullPrice',
}

export type ApiPricingBreakdown = {
  sellerPrice: Price;
  sellerEarning?: Price;
  buyerFees: BuyerFeesType;
  fullPrice?: Price;
};

export type PricingBreakdown = {
  fullPrice: Price;
  sellerInitialPrice?: Price;
} & ApiPricingBreakdown;

export type BuyerFeesType = {
  hasCrossBorderFees: boolean;
  includesAuthenticationFees: boolean;
} & Omit<FeesType, 'name'>;

export type FeesType = {
  name: string;
  feeType: 'percent' | 'cap' | 'flat';
  amount: {
    cents: number;
    currency: string;
    formatted: string;
  };
  percent: {
    value: number;
    formatted: string;
  };
  cap?: {
    type: 'min' | 'max';
    percent: {
      value: number;
      formatted: string;
    };
  };
};

export type BuyerFeesOnSellerSide = {
  hasCrossBorderFees: boolean;
};

export type MinimumDataPrice = {
  formatted: string;
  cents: number;
};

export type MinimumPricingBreakdown = {
  // amount seen by the seller (sellerEarning + seller fees)
  sellerPrice: MinimumDataPrice;

  // amount received by the seller
  sellerEarning?: MinimumDataPrice;

  // initial amount seen by the seller before a price drop (sellerEarning + seller fees)
  sellerInitialPrice?: MinimumDataPrice;

  // amount paid by the buyer on top of the sellerPrice
  buyerFees: MinimumDataPrice;

  // total amount paid by a buyer (sellerPrice + buyer fees + (optional) border fees)
  fullPrice: MinimumDataPrice;

  // fees added if cross countries
  hasCrossBorderFees: boolean;

  // fees added if authentication is required
  includesAuthenticationFees?: boolean;
};
